export default __webpack_public_path__ + "static/media/github.8962f6f4.png";